<template>
  <span class="text-left">
    <ed-button class="btn btn-actionbar"
        @click="validateCancelInvoice()"
        :disabled='disabled'
      >Cancel
    </ed-button>

    <ed-modal
      :show='showModal'
      @close='showModal = false'
      @confirm='cancelInvoice()'
      title=''
      xsubtitle=''
      primaryButton='Yes'
      secondaryButton='No'
    >
      <span slot="body">
        <p class="col-md-8 lh15">
          Are you sure you want to cancel invoice {{ name }}?
        </p>
        <div class="clear"></div>
      </span>
    </ed-modal>
  </span>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    ids: Array
  },

  data() {
    return {
      showModal: false
    }
  },

  computed: {
    id() {
      return this.ids[0] && this.ids[0].data.PaymentInvoiceID
    },
    name() {
      return this.ids[0] && this.ids[0].data.InvoiceNumber
    }
  },

  created() {
    //
  },

  methods: {
    validateCancelInvoice() {
      this.api.forms.post(
        this.api.$.invoice.list.canCancelInvoice,
        {
          id: this.id
        }
      ).then(result => {
        if (result && result.data) {
          if (result.data.Errors && result.data.Errors.length) {
            alert(result.data.Errors[0].Message)
          } else {
            this.showModal = true
          }
        }
      })
    },

    cancelInvoice() {
      this.api.forms.post(
        this.api.$.invoice.list.cancelInvoice,
        {
          id: this.id
        }
      ).then(result => {
        if (result && result.data && result.data.SuccessMessage === 'Success') {
          this.$notifications.notify({
            message: `You have successfully cancelled invoice ${this.ids[0].data.InvoiceNumber}`,
            type: 'info',
            placement: { from: 'top', align: 'center' }
          })
          this.$emit('success', this.ids[0].data)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/Invoices/actions/cancel.vue